import styled from '@material-ui/styles/styled';
import Div, { DivProps } from '@vkontakte/vkui/dist/components/Div/Div';

export default styled(Div)({
  padding: '16px 24px',
}) as React.FC<DivProps>;
